// 261030104901
(function () {
  'use strict';

  var CAT_TAGS = {
    'cat:aeg': 18,
    'cat:gas': 18,
    'cat:co2': 18
  };

  var AGE_TAGS = {
    'age:r10': 10,
    'age:r14': 14,
    'age:r18': 18
  };

  // 変えると動かなくなる: AGE_TAGS / CAT_TAGS に足した年齢はここにも足す（無い年齢は確認対象から外れる）
  var GROUPS = {
    18: {
      badge: '18歳以上',
      question: '上記は18歳以上を対象とした製品です。ご購入者・ご使用者は18歳以上ですか？',
      notes: [
        '対象商品は18歳以上の方を対象とした製品です。18歳未満の方はご購入いただけません。',
        '18歳以上の方が18歳未満の方に代わって購入すること、また購入後に譲渡・貸与することも、各都道府県の条例により禁じられています。',
        'ご注文の確定をもって、ご自身が18歳以上であることを申告いただいたものとして取り扱います。年齢に偽りがあった場合は民法第21条に定める未成年者の詐術に該当するため、未成年であることを理由としたご契約の取り消しには応じられません。'
      ],
      check: 'はい、ご購入者・ご使用者はいずれも18歳以上です'
    },
    14: {
      badge: '14歳以上',
      question: '上記はメーカーが対象年齢を14歳以上と定めた製品です。ご使用者は14歳以上ですか？',
      notes: [
        '対象商品は、法令上は10歳以上を対象とする区分の製品ですが、メーカーが対象年齢を14歳以上と定めています。',
        '10歳以上14歳未満の方のご使用を直接制限する法令はありません。ただし、メーカーの定めた対象年齢を下回るご使用によって生じた事故・トラブルについて、当店は一切の責任を負いかねます。',
        '年齢区分の根拠となる青少年保護育成条例は都道府県ごとに定められており、お住まいの地域によって規制の内容が異なる場合があります。最終的なご判断はお客様ご自身の責任でお願いいたします。'
      ],
      check: 'はい、上記を確認のうえ同意します'
    },
    10: {
      badge: '10歳以上',
      question: '上記は10歳以上を対象とした製品です。ご使用者は10歳以上ですか？',
      notes: [
        '対象商品は10歳以上を対象とした製品です。10歳未満の方はご使用いただけません。',
        'この年齢区分は青少年保護育成条例に基づくものです。条例は都道府県ごとに定められているため、お住まいの地域によって規制の内容が異なる場合があります。',
        'お住まいの地域の条例をご確認のうえ、お客様ご自身の責任においてご購入をご判断ください。'
      ],
      check: 'はい、上記を確認のうえ同意します'
    }
  };

  var FORM_ID = 'cart-form';
  var CHECKOUT_ID = 'checkout';
  var CHECKOUT_NAME = 'checkout';

  var FETCH_TIMEOUT = 3500;
  var TOTAL_TIMEOUT = 5000;

  var FALLBACK_CONFIRM =
    'カートに年齢制限のある商品が含まれています。\n' +
    'ご購入者・ご使用者は対象年齢に達していますか？\n\n' +
    '「OK」を押すと、対象年齢に達していることを確認したものとして注文手続きに進みます。';

  var tagCache = {};
  var lastGroups = null;
  var bypass = false;
  var pending = false;
  var modal = null;
  var lastFocus = null;
  var refreshTimer = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function warn() {
    if (window.console && console.warn) console.warn.apply(console, arguments);
  }

  function isCartTemplate() {
    var main = document.querySelector('main[data-template]');
    if (main && main.dataset.template) return main.dataset.template.split('.')[0] === 'cart';
    return /^\/cart(\/|$)/.test(window.location.pathname);
  }

  function getJSON(url) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (ctrl) opts.signal = ctrl.signal;

    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, FETCH_TIMEOUT);

    return fetch(url, opts).then(
      function (r) {
        clearTimeout(timer);
        return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status));
      },
      function (e) {
        clearTimeout(timer);
        return Promise.reject(e);
      }
    );
  }

  function withTimeout(p, ms) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(v) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(v);
      }
      var timer = setTimeout(function () {
        warn('[age-check] 判定がタイムアウトしました');
        finish(null);
      }, ms);
      p.then(finish, function (e) { warn('[age-check] 判定に失敗', e); finish(null); });
    });
  }

  function requiredAge(tags) {
    if (tags == null) return 18;
    if (!tags.length) return null;

    var age = null;
    var cat = null;

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).trim().toLowerCase();

      if (AGE_TAGS[t] != null) {
        age = age === null ? AGE_TAGS[t] : Math.max(age, AGE_TAGS[t]);
      } else if (CAT_TAGS[t] != null) {
        cat = cat === null ? CAT_TAGS[t] : Math.max(cat, CAT_TAGS[t]);
      }
    }

    return age !== null ? age : cat;
  }

  function loadTags(handles) {
    var need = [];
    for (var i = 0; i < handles.length; i++) {
      if (handles[i] && need.indexOf(handles[i]) === -1 && !(handles[i] in tagCache)) {
        need.push(handles[i]);
      }
    }
    if (!need.length) return Promise.resolve();

    return Promise.all(need.map(function (h) {
      return getJSON('/products/' + encodeURIComponent(h) + '.js')
        .then(function (p) { tagCache[h] = (p && p.tags) || []; })
        .catch(function () {

          tagCache[h] = null;
          warn('[age-check] タグを取得できませんでした:', h);
          setTimeout(function () {
            if (tagCache[h] === null) delete tagCache[h];
          }, 30000);
        });
    }));
  }

  function buildGroups(cart) {
    var groups = {};

    (cart.items || []).forEach(function (item) {
      var age = requiredAge(tagCache[item.handle]);
      if (age === null || !GROUPS[age]) return;

      if (!groups[age]) groups[age] = [];

      var name = item.product_title || item.title || '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        name += '（' + item.variant_title + '）';
      }

      var found = null;
      for (var i = 0; i < groups[age].length; i++) {
        if (groups[age][i].title === name) { found = groups[age][i]; break; }
      }
      if (found) found.qty += item.quantity;
      else groups[age].push({ title: name, qty: item.quantity });
    });

    return groups;
  }

  function refresh() {
    return getJSON('/cart.js')
      .then(function (cart) {
        return loadTags((cart.items || []).map(function (i) { return i.handle; }))
          .then(function () {
            lastGroups = buildGroups(cart);
            return lastGroups;
          });
      })
      .catch(function (e) {
        warn('[age-check] カート情報を取得できませんでした', e);

        return (lastGroups && Object.keys(lastGroups).length) ? lastGroups : { 18: [] };
      });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refresh(); }, 400);
  }

  function injectStyle() {
    if (document.getElementById('a97-agegate-style')) return;
    var style = document.createElement('style');
    style.id = 'a97-agegate-style';
    style.textContent = [

      '.a97-agegate{position:fixed;top:0;right:0;bottom:0;left:0;inset:0;z-index:2147483000;',
      'display:flex;align-items:flex-start;justify-content:center;padding:16px;',
      'margin:0;border:0;background:transparent;color:inherit;',
      'width:auto;height:auto;max-width:none;max-height:none;',
      'overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;',
      'font-family:inherit;}',
      '.a97-agegate:not([open]){display:none;}',
      '.a97-agegate::backdrop{background:transparent;}',
      '.a97-agegate__overlay{position:fixed;top:0;right:0;bottom:0;left:0;inset:0;background:rgba(0,0,0,.55);}',

      '.a97-agegate__panel{position:relative;display:flex;flex-direction:column;width:100%;max-width:560px;',
      'margin:auto;',
      'max-height:calc(100vh - 32px);',
      'max-height:calc(100dvh - 32px);',
      'background:#fafaf8;color:#1a1a18;',
      'border:1px solid #d3cec5;border-radius:8px;box-shadow:0 12px 40px rgba(0,0,0,.28);overflow:hidden;}',

      '.a97-agegate__head{padding:20px 20px 12px;border-bottom:1px solid #d3cec5;}',
      '.a97-agegate__title{margin:0 0 6px;font-size:17px;font-weight:700;line-height:1.4;color:#1a1a18;}',
      '.a97-agegate__lead{margin:0;font-size:13px;line-height:1.6;color:#55524c;}',

      '.a97-agegate__body{min-height:0;padding:4px 20px 16px;overflow-y:auto;',
      '-webkit-overflow-scrolling:touch;overscroll-behavior:contain;}',

      '.a97-agegate__group{padding:16px 0;border-bottom:1px dashed #d3cec5;}',
      '.a97-agegate__group:last-child{border-bottom:0;}',
      '.a97-agegate__badge{display:inline-block;padding:3px 9px;border-radius:999px;font-size:12px;',
      'font-weight:700;letter-spacing:.02em;background:#8B0000;color:#fff;}',
      '.a97-agegate__group[data-age="14"] .a97-agegate__badge{background:#8a5a00;}',
      '.a97-agegate__group[data-age="10"] .a97-agegate__badge{background:#3f6212;}',

      '.a97-agegate__items{margin:10px 0 0;padding:0;list-style:none;font-size:13px;line-height:1.6;}',
      '.a97-agegate__items li{position:relative;padding:2px 0 2px 14px;}',
      '.a97-agegate__items li::before{content:"";position:absolute;left:3px;top:.72em;width:4px;height:4px;',
      'border-radius:50%;background:#1a1a18;opacity:.5;}',
      '.a97-agegate__qty{color:#6b675f;}',
      '.a97-agegate__question{margin:12px 0 0;font-size:13px;font-weight:700;line-height:1.6;}',

      '.a97-agegate__notes{margin:8px 0 0;padding:10px 12px;border-radius:6px;background:#efece6;}',
      '.a97-agegate__notes ul{margin:0;padding:0;list-style:none;}',
      '.a97-agegate__notes li{position:relative;padding:0 0 0 12px;font-size:12px;line-height:1.7;color:#4a4741;}',
      '.a97-agegate__notes li+li{margin-top:5px;}',
      '.a97-agegate__notes li::before{content:"・";position:absolute;left:0;}',

      '.a97-agegate__check{display:flex;align-items:flex-start;margin:12px 0 0;padding:11px 12px;',
      'cursor:pointer;border:1px solid #d3cec5;border-radius:6px;background:#fff;',
      'font-size:13px;line-height:1.5;font-weight:700;color:#1a1a18;}',
      '.a97-agegate__check input{flex:0 0 auto;width:18px;height:18px;margin:0 9px 0 0;',
      '-webkit-appearance:checkbox;appearance:checkbox;accent-color:#030302;cursor:pointer;}',
      '.a97-agegate__check.is-checked{border-color:#030302;background:#f2efe9;}',
      '@media (hover:hover){.a97-agegate__check:hover{background:#f5f2ec;}}',

      '.a97-agegate__foot{display:flex;gap:10px;padding:14px 20px;',
      'padding-bottom:14px;',
      'padding-bottom:calc(14px + env(safe-area-inset-bottom));',
      'border-top:1px solid #d3cec5;background:#fafaf8;}',
      '.a97-agegate__foot button{flex:1;margin:0;padding:13px 12px;border-radius:6px;font-size:14px;',
      'font-weight:700;line-height:1.3;cursor:pointer;font-family:inherit;',
      '-webkit-appearance:none;appearance:none;border:1px solid #d3cec5;min-height:44px;}',
      '.a97-agegate__deny{background:transparent;color:#1a1a18;}',
      '@media (hover:hover){.a97-agegate__deny:hover{background:#efece6;}}',
      '.a97-agegate__accept{flex:1.4;background:#030302;color:#fafaf8;border-color:#030302;}',
      '.a97-agegate__accept[aria-disabled="true"]{opacity:.4;}',
      '.a97-agegate__hint{margin:0;padding:0 20px 14px;font-size:12px;line-height:1.5;',
      'color:#6b675f;text-align:center;background:#fafaf8;}',
      '.a97-agegate__hint:empty{display:none;}',

      'html.a97-agegate-open,body.a97-agegate-open{overflow:hidden;}',

      '.a97-checkout-busy{position:relative;pointer-events:none;}',
      '.a97-checkout-busy,.a97-checkout-busy *{color:transparent !important;}',
      '.a97-checkout-busy::after{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;',
      'margin:-9px 0 0 -9px;box-sizing:border-box;border:2px solid var(--color-primary-button-text,#fff);',
      'border-right-color:transparent;border-radius:50%;animation:a97-agegate-spin .7s linear infinite;}',
      '@keyframes a97-agegate-spin{to{transform:rotate(360deg);}}',

      '@media (max-width:480px){',
      '.a97-agegate{padding:0;align-items:flex-end;}',
      '.a97-agegate__panel{max-width:none;margin:auto 0 0;',
      'max-height:92vh;',
      'max-height:92dvh;',
      'border-radius:12px 12px 0 0;}',
      '.a97-agegate__foot{flex-direction:column-reverse;}',
      '.a97-agegate__foot button+button{margin-bottom:10px;}',
      '.a97-agegate__accept{flex:1;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function groupHTML(age, items) {
    var g = GROUPS[age];

    var list = items.length
      ? '<ul class="a97-agegate__items">' + items.map(function (it) {
          return '<li>' + esc(it.title) +
            (it.qty > 1 ? ' <span class="a97-agegate__qty">× ' + esc(it.qty) + '</span>' : '') + '</li>';
        }).join('') + '</ul>'
      : '';

    var notes = '<div class="a97-agegate__notes"><ul>' + g.notes.map(function (n) {
      return '<li>' + esc(n) + '</li>';
    }).join('') + '</ul></div>';

    return '<section class="a97-agegate__group" data-age="' + esc(age) + '">' +
      '<span class="a97-agegate__badge">' + esc(g.badge) + '対象商品</span>' +
      list +
      '<p class="a97-agegate__question">' + esc(g.question) + '</p>' +
      notes +
      '<label class="a97-agegate__check">' +
        '<input type="checkbox">' +
        '<span>' + esc(g.check) + '</span>' +
      '</label>' +
    '</section>';
  }

  function buildModal(groups) {
    var ages = Object.keys(groups)
      .map(Number)
      .filter(function (a) { return GROUPS[a]; })
      .sort(function (a, b) { return b - a; });

    var el = document.createElement('dialog');
    el.className = 'a97-agegate';
    el.setAttribute('aria-labelledby', 'a97-agegate-title');
    el.setAttribute('aria-describedby', 'a97-agegate-lead');
    el.innerHTML =
      '<div class="a97-agegate__overlay"></div>' +
      '<div class="a97-agegate__panel" tabindex="-1">' +
        '<div class="a97-agegate__head">' +
          '<h2 class="a97-agegate__title" id="a97-agegate-title">年齢確認のお願い</h2>' +
          '<p class="a97-agegate__lead" id="a97-agegate-lead">カートに年齢制限のある商品が含まれています。内容をご確認のうえ、該当する項目にチェックを入れてください。</p>' +
        '</div>' +
        '<div class="a97-agegate__body">' +
          ages.map(function (a) { return groupHTML(a, groups[a]); }).join('') +
        '</div>' +
        '<p class="a97-agegate__hint" role="status" aria-live="polite"></p>' +
        '<div class="a97-agegate__foot">' +
          '<button type="button" class="a97-agegate__deny">いいえ（カートに戻る）</button>' +
          '<button type="button" class="a97-agegate__accept" aria-disabled="true">同意して注文手続きへ</button>' +
        '</div>' +
      '</div>';
    return el;
  }

  function closeModal() {
    if (!modal) return;
    var m = modal;
    modal = null;
    try { if (m.open && typeof m.close === 'function') m.close(); } catch (e) {}
    m.remove();
    document.documentElement.classList.remove('a97-agegate-open');
    document.body.classList.remove('a97-agegate-open');
    document.removeEventListener('keydown', onKeydown, true);
    release();
    if (lastFocus && lastFocus.isConnected && lastFocus.focus) {
      try { lastFocus.focus(); } catch (e) {}
    }
    lastFocus = null;
  }

  function focusables() {
    if (!modal) return [];
    return [].slice.call(
      modal.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (!modal) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function openModal(groups, onAccept) {
    injectStyle();

    if (modal) {
      try { if (modal.open) modal.close(); } catch (e) {}
      modal.remove();
      modal = null;
      document.removeEventListener('keydown', onKeydown, true);
    }

    lastFocus = document.activeElement;
    modal = buildModal(groups);
    document.body.appendChild(modal);
    // 変えると動かなくなる: showModal でないとドロワー（top layer）の下に隠れる
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
    document.documentElement.classList.add('a97-agegate-open');
    document.body.classList.add('a97-agegate-open');

    var boxes = [].slice.call(modal.querySelectorAll('.a97-agegate__check input'));
    var accept = modal.querySelector('.a97-agegate__accept');
    var hint = modal.querySelector('.a97-agegate__hint');

    function unchecked() {
      return boxes.filter(function (b) { return !b.checked; });
    }

    function sync() {
      var left = unchecked().length;

      accept.setAttribute('aria-disabled', left ? 'true' : 'false');
      boxes.forEach(function (b) {
        var label = b.closest ? b.closest('.a97-agegate__check') : b.parentNode;
        if (label) label.classList.toggle('is-checked', b.checked);
      });
      if (!left) hint.textContent = '';
    }

    boxes.forEach(function (b) { b.addEventListener('change', sync); });
    sync();

    accept.addEventListener('click', function () {
      var left = unchecked();
      if (left.length) {
        hint.textContent = '未確認の項目が' + left.length + '件あります。チェックを入れてください。';
        try { left[0].focus(); } catch (e) {}
        return;
      }
      closeModal();
      onAccept();
    });

    modal.querySelector('.a97-agegate__deny').addEventListener('click', closeModal);
    modal.querySelector('.a97-agegate__overlay').addEventListener('click', closeModal);

    modal.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(); });
    document.addEventListener('keydown', onKeydown, true);

    var panel = modal.querySelector('.a97-agegate__panel');
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
  }

  function findCheckoutButton(form) {
    if (!form) return null;
    function ok(b) { return b && b.form === form && (b.type === 'submit' || b.type === 'image'); }

    var b = document.getElementById(CHECKOUT_ID);
    if (ok(b)) return b;

    var list = document.querySelectorAll('[name="' + CHECKOUT_NAME + '"]');
    for (var i = 0; i < list.length; i++) {
      if (ok(list[i])) return list[i];
    }
    return null;
  }

  function hardFallback(form) {
    warn('[age-check] 通常のサブミットに失敗したため /checkout へ直接遷移します');
    try {
      if (form && form.isConnected) {
        var hidden = form.querySelector('input[type="hidden"][data-agegate]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = CHECKOUT_NAME;
          hidden.value = '';
          hidden.setAttribute('data-agegate', '');
          form.appendChild(hidden);
        }
        form.submit();
        return;
      }
    } catch (e) {
      warn('[age-check] form.submit() も失敗', e);
    }
    window.location.assign('/checkout');
  }

  function submitCheckout() {
    var form = document.getElementById(FORM_ID);
    var btn = findCheckoutButton(form);

    holdUntilLeave();
    if (!form || !btn) { hardFallback(form); return; }

    bypass = true;

    setTimeout(function () {
      if (bypass) {
        bypass = false;
        hardFallback(form);
      }
    }, 300);

    try {
      if (form.requestSubmit) {
        form.requestSubmit(btn);
      } else {

        bypass = false;
        hardFallback(form);
      }
    } catch (err) {
      bypass = false;
      warn('[age-check] requestSubmit に失敗', err);
      hardFallback(form);
    }
  }

  function setBusy(on) {
    var btn = findCheckoutButton(document.getElementById(FORM_ID));
    if (!btn) return;
    if (on) {
      injectStyle();
      btn.classList.add('a97-checkout-busy');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('a97-checkout-busy');
      btn.removeAttribute('aria-busy');
    }
  }

  var leaveTimer = null;

  function release() {
    clearTimeout(leaveTimer);
    pending = false;
    setBusy(false);
  }

  var LEAVE_MAX_MS = 10000;
  function holdUntilLeave() {
    pending = true;
    setBusy(true);
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(release, LEAVE_MAX_MS);
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) release(); });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== FORM_ID) return;

    if (bypass) { bypass = false; return; }

    // 変えると動かなくなる: cart-form の submit ボタンは #checkout だけ、という前提
    if (e.submitter && e.submitter.name && e.submitter.name !== CHECKOUT_NAME) return;

    e.preventDefault();
    e.stopPropagation();

    if (pending) return;
    pending = true;
    setBusy(true);

    withTimeout(refresh(), TOTAL_TIMEOUT)
      .then(function (groups) {

        if (!groups) groups = { 18: [] };

        var hasTarget = Object.keys(groups).some(function (a) { return GROUPS[a]; });
        if (!hasTarget) {
          release();
          submitCheckout();
          return;
        }

        openModal(groups, submitCheckout);
      })
      .catch(function (err) {

        warn('[age-check] モーダルの表示に失敗', err);
        release();
        try {
          if (window.confirm(FALLBACK_CONFIRM)) submitCheckout();
        } catch (e2) {
          submitCheckout();
        }
      });
  }, true);

  function start() {
    var drawer = document.querySelector('cart-drawer-component');

    if (!document.getElementById(FORM_ID) && !drawer) return;

    if (isCartTemplate()) {

      refresh();
    }

    if (drawer && window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t instanceof HTMLDialogElement && t.open) { scheduleRefresh(); break; }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['open'], subtree: true });
    }

    var comp = drawer || document.querySelector('cart-items-component');
    if (comp && window.MutationObserver) {
      new MutationObserver(function () {
        if (drawer) {
          var dlg = drawer.querySelector('dialog');
          if (!dlg || !dlg.open) return;
        }
        scheduleRefresh();
      }).observe(comp, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();